import { useCallback, useContext, useState } from 'react';

import { context as DependencyContext } from '../../context/dependency';

const useCreateProjectIssue = () => {
  const dependency = useContext(DependencyContext);

  const [loading, setLoading] = useState(0);
  const createProjectIssue = useCallback(
    async (projectId: string, body: string, onCreate: () => void) => {
      setLoading((loading) => ++loading);
      try {
        await dependency.projectWebApi.createProjectIssue(projectId, 'Untitled', body);
        dependency.messageDispatcher.notifyUnimportant('project_detail_page.project_issue.message.post');
        onCreate();
      } catch (err) {
        dependency.errorPresenter.showAsNonFatal(new Error('project_detail_page.project_issue.message.post.failed'));
      }
      setLoading((loading) => --loading);
    },
    [dependency],
  );

  return { createProjectIssue, loading: loading > 0 };
};

export default useCreateProjectIssue;
